import { z } from 'zod';
// Fase 3b — módulo Secretos (solo root). Mismo alfabeto que GCP Secret
// Manager acepta para un secretId; el valor además debe existir en GCP y
// tener el prefijo de su plataforma (lo valida secretos.service).
const secretName = z.string().regex(/^[A-Za-z0-9_-]{1,255}$/, 'Nombre de secret inválido');
// Fase 3c — mismo alfabeto que los slugs reales de Onboarding (Beauty_mx, rancho_us, promo1800);
// máx. 60 = largo de clients.client_slug en Onboarding.
const clientSlug = z.string().regex(/^[A-Za-z0-9_]{1,60}$/, 'client_slug inválido: solo letras, números y "_", máx. 60');
export const actualizarSecretoSchema = z
    .object({
    secret_comercial: secretName.nullable().optional(),
    secret_ads: secretName.nullable().optional(),
    client_slug: clientSlug.nullable().optional(),
    sync: z.boolean().optional(),
})
    .refine(v => Object.values(v).some(x => x !== undefined), { message: 'Nada que actualizar' });
//# sourceMappingURL=secretos.js.map